import {
	Edit,
	NumberInput,
	ReferenceInput,
	SelectInput,
	TextInput,
	ImageInput,
	ImageField,
	LongTextInput,
	ReferenceManyField,
	Datagrid,
	DateField,
	TextField,
	TabbedForm,
	FormTab,
	CardActions,
	ListButton,
	RefreshButton,
	translate,
	FormDataConsumer
} from "react-admin";
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
} from "react-google-maps";
import { connect } from "react-redux";
import { compose, withProps } from "recompose";

import Button from "@material-ui/core/Button";
import React from "react";
import LineAction from "./LineAction";
import { required } from "../../services/validate";
import { typeRepair } from "../../constant/TypeRepair";

const MapComponent = compose(
	withProps({
		googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDn2ZjgClSV3LNK9QvqLOngHo0QbH0Pt64&v=3.exp&libraries=geometry,drawing,places",
		loadingElement: <div style={{ height: "100%" }} />,
		containerElement: <div style={{ height: "400px" }} />,
		mapElement: <div style={{ height: "100%" }} />,
	}),
	withScriptjs,
	withGoogleMap
)((props) =>
	<GoogleMap
		defaultZoom={18}
		defaultCenter={{ lat: props.lat ? props.lat : 13.7563284, lng: props.lng ? props.lng : 13.7563284 }}
		clickableIcons={false}
		options={{
			draggable: false,
			disableDefaultUI: true,
			draggableCursor: "default"
		}}
	>
		{props.isMarkerShown && <Marker defaultCursor="default" position={{ lat: props.lat ? props.lat : 13.7563284, lng: props.lng ? props.lng : 13.7563284 }} />}
	</GoogleMap>
);

const RepairTitle = ({ translate, record }) => {
	return (
		<span>
			{`${translate("repair.repair")}`} {record ? `"${record.ticket_no}"` : ""}
		</span>
	);
};

const Title = translate(RepairTitle);

const Actions = ({ basePath, data, resource }) => {
	return (
		<CardActions>
			<ListButton basePath={basePath} />
			{data && <LineAction repairId={data ? data._id : ""} isSent={data ? data.isSent : false} status={data ? data.status : 1} project={data.project} />}
			{/* <Button
      onClick={() => sendRepairToLine(data._id)}
      primary="true"
      style={{ color: "#3f51b5" }}
    >
      <SendIcon style={{ marginRight: 10 }} />
      Send to Line
    </Button> */}
			{/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
			<RefreshButton />
		</CardActions>
	);
};

const RepairEdit = props => {
	const project = localStorage.getItem("project");
	const role = localStorage.getItem("role");
	const isRequiredImage = (props.currentForm && props.currentForm.status === 4 && !(props.currentForm.message && props.currentForm.message.image));
	console.log("PROPS: ", props);
	return (
		<Edit actions={<Actions />} title={<Title />} {...props}>
			<TabbedForm {...props}>
				<FormTab label="repair.tab.inform">
					<ReferenceInput
						disabled
						defaultValue={project}
						source="project"
						reference="project"
					>
						<SelectInput optionText="name" />
					</ReferenceInput>
					<ReferenceInput disabled source="room_inform" reference="room">
						<SelectInput optionText="name" />
					</ReferenceInput>
					<ReferenceInput
						disabled
						label="ผู้ที่แจ้ง"
						source="user_inform"
						reference="user"
					>
						<SelectInput optionText="email" />
					</ReferenceInput>
					<ReferenceInput disabled source="user_inform" reference="user">
						<SelectInput optionText="mobile" />
					</ReferenceInput>
					<ReferenceInput
						disabled
						label="ประเภทข้อมูล"
						source="type_data"
						reference="repairtypedata"
					>
						<SelectInput optionText="name" />
					</ReferenceInput>
					<ReferenceInput
						disabled
						label="ข้อมูล"
						source="type"
						reference="repairtype"
					>
						<SelectInput optionText="name" />
					</ReferenceInput>
					<DateField
						source="createdAt"
						label="วันที่แจ้งซ่อม"
						locales="th-TH"
						options={{
							day: "numeric",
							month: "short",
							year: "numeric",
							hour: "numeric",
							minute: "numeric"
						}}
					/>
					<LongTextInput disabled source="description" />
					<ImageField source="images" src="url" label="url" />
					<FormDataConsumer>
						{({ formData }) => {
							return (
								(formData && formData.location) ? <MapComponent isMarkerShown lat={formData.location.latitude} lng={formData.location.longitude} /> : null
							);
						}}
					</FormDataConsumer>

				</FormTab>
				<FormTab label="repair.tab.messagestatus">
					<ReferenceManyField
						label="ข้อความ"
						reference="message"
						target="ticket"
					>
						<Datagrid>
							<DateField
								source="createdAt"
								locales="th-TH"
								options={{
									day: "numeric",
									month: "short",
									year: "numeric",
									hour: "numeric",
									minute: "numeric"
								}}
							/>
							<TextField source="title" />
							<TextField source="message" />
							<ImageField label="รูป" source="image.url" title="Image" />
						</Datagrid>
					</ReferenceManyField>
					<SelectInput
						source="status"
						choices={typeRepair.map((t, i) => ({ ...t, disabled: role === "superadmin" ? false : i === 4 }))}
					/>
					{
						role === "superadmin" &&
						<LongTextInput label="หมายเหตุ" source="note" />
					}
					<TextInput
						validate={[required()]}
						multiline
						rows={"3"}
						fullWidth
						source="message.message"
					/>
					<ImageInput multiple={false} source="message.image" accept="image/*" validate={isRequiredImage ? [required()] : []}>
						<ImageField source="url" title="title" />
					</ImageInput>
					{isRequiredImage &&
						<span style={{ color: "#f44336" }}>กรุณาแนบรูป</span>}
					{/* <LongTextInput label="Message to user" source="message" /> */}
				</FormTab>
				<FormTab label="repair.tab.rating">
					<NumberInput disabled source="rating" />
				</FormTab>
			</TabbedForm>
		</Edit>
	);
};

const mapStateToProps = state => ({
	currentForm: state.form["record-form"] ? state.form["record-form"]["values"] : null
});

export default connect(mapStateToProps)(RepairEdit);



// WEBPACK FOOTER //
// ./src/components/repair/RepairEdit.js